const links = [
	{
		innerSlug: '',
		home: true,
		templates: ['taxonomy-collapse', 'content', 'biography'],
		components: ['html-raw'],
	},
	{
		innerSlug: '/disciplines/',
		name: 'events',
		active: true,
		components: ['panel-announces'], // временный статичный блок
		templates: [],
	},
	{
		innerSlug: '/programmes/',
		name: 'programmes',
		active: true,
		components: ['panel-programs'], // временный статичный блок
		templates: [],
	},
	// {
	// 	innerSlug: '/biography/',
	// 	name: 'Биография и опыт',
	// 	active: true,
	// 	components: ['html-raw'],
	// 	templates: ['biography', 'content'],
	// },
	{
		innerSlug: '/publications/',
		name: 'publications',
		active: true,
		components: ['panel-publications', 'panel-sources-strings'],
		templates: ['publications'],
	},
	{
		innerSlug: '/content/',
		name: 'photoVideo',
		active: true,
		components: [
			'panel-navigation', 'panel-playlist-youtube', 'panel-program-gallery-flickr', 'author-content',
		],
	},
];

export default links;
